import { render, staticRenderFns } from "./CopyStakeWebStreamersStats.vue?vue&type=template&id=24d4b8c9&lang=pug"
import script from "./CopyStakeWebStreamersStats.vue?vue&type=script&lang=ts"
export * from "./CopyStakeWebStreamersStats.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports